import styled from "styled-components";

export const InfoContainer = styled.div`
    color: #fff;
    background: ${({lightBg}) => (lightBg ? '#f9f9f9' : '#010606')};
    padding: 100px 0;

    @media screen and (max-width: 768px) {
        padding: 80px 0;
    }
`;

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    width: 100%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
`;

export const InfoRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};
    grid-gap: 60px;

    @media screen and (max-width: 768px) {
        grid-template-areas: 'col1' 'col2';
        grid-gap: 50px;
    }
`;

export const Column1 = styled.div`
    grid-area: col1;
`;

export const Column2 = styled.div`
    grid-area: col2;
`;

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;

    @media screen and (max-width: 768px) {
        padding-bottom: 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const TopLine = styled.div`
    color: #38A7BA;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`;

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 700;
    letter-spacing: -1.5px;
    color: ${({lightText}) => (lightText ? '#f7f8fa' : '#010606')};

    @media screen and (max-width: 768px) {
        font-size: 40px;
        letter-spacing: -1px;
    }

    @media screen and (max-width: 480px) {
        font-size: 32px;
        letter-spacing: -0.5px;
    }
`;

export const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 1.5;
    font-weight: 400;
    color: ${({darkText}) => (darkText ? '#4a5568' : 'rgba(255, 255, 255, 0.9)')};

    @media screen and (max-width: 768px) {
        font-size: 16px;
    }
`;

export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 16px;

    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
    }
`;

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
    position: relative;
    width: 100%;
    padding-bottom: 120%; /* Aspect ratio for the iframe */
`;

export const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
    display: ${({imgDisplay}) => (imgDisplay ? 'block' : 'none')};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const Iframe = styled.iframe`
    display: ${({iframeDisplay}) => (iframeDisplay ? 'block' : 'none')};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
`;